import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
}

export const getters = {}

export const mutations = {
    SET_INVOICES(state, objects) {
        let updatedObjects = {}
        for (let key in objects) {
            if (!objects[key].deleted_at) {
                // Remove the '__typename' field that gets added by GraphQL
                delete objects[key].__typename
                // Stage the update so we can just do one Vue.set
                updatedObjects[key] = objects[key]
            } else if (state.objects.hasOwnProperty(objects[key].id)) {
                // Immediately delete the object
                Vue.delete(state.objects, objects[key].id)
            }
        }
        state.objects = {
            ...updatedObjects,
        }
        // console.log(state.objects)

    },
    SET_INVOICE(state, objects) {
        state.currentPhoto = objects
    },
}

export const actions = {
    init({ commit, rootState }) {
        // Initialise the GraphQL client
        graphqlClient = createGraphQLClient(rootState)
    },
    async getInvoices({ commit }) {

        try {
            const response = await
                graphqlClient.query({
                    query: gql`
                    query{
                      getClientInvoices {
                        type       
                        date     
                        invoice_id
                        invoice_number
                        reference
                        amount_due
                        amount_paid
                        client
                        status
                        subtotal
                        total_tax
                        total
                        currency_code
                        payments {
                          payment_id
                          date
                          amount
                          reference
                          currency_rate
                        }
                      }
                    }
                    `,
                })
            graphqlClient.cache.reset()
            // console.log(response.data)
            commit('SET_INVOICES', response.data.getClientInvoices)

        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async createInvoice({ commit, dispatch }, {type, contactName, listItems} = {}) {
        try {
            // let that = this
            await graphqlClient.mutate({
                mutation: gql`
                mutation createInvoice($Type: String $ContactName: String $ListItems: lineinput)  {
                  createInvoice(invoice:{type:$Type contactname: $ContactName listitems:$ListItems }) {
                    id
                  }
                }
                `,
                variables: {Type: type, ContactName: contactName,ListItems: listItems},
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async deletePhoto({ commit, dispatch }, {photoId, exceptionId, url} = {}) {
        try {
            // let that = this
            const response = await graphqlClient.mutate({
                mutation: gql`
                    mutation deletePhoto($Id: Int $Exception: Int $Url: String)  {
                      deletePhoto(id: $Id photo:{collection_instance_exception_id: $Exception url:$Url }) {
                        id
                      }
                    }
                `,
                variables: {Id: photoId, Exception: exceptionId, Url: url},
            })
            commit('SET_PHOTOS', response.data.deletePhoto)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async updatePhoto({ commit, dispatch }, {photoId, exceptionId, url} = {}) {
        try {
            // let that = this
            const response = await graphqlClient.mutate({
                mutation: gql`
                    mutation updatePhoto($Id: Int $Exception: Int $Url: String)  {
                      updatePhoto(id: $Id photo:{collection_instance_exception_id: $Exception url:$Url }) {
                        id
                      }
                    }
                `,
                variables: {Id: photoId, Exception: exceptionId, Url: url},
            })
            commit('SET_PHOTOS', response.data.updatePhoto)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
}
